import { useEffect } from 'react';

function useProfileMenuWidthSync() {
  useEffect(() => {
    function syncProfileMenuWidth() {
      const activator = document.querySelector('.Polaris-TopBar-Menu__ActivatorWrapper');
      const popover = document.querySelector('.Polaris-Popover__ContentContainer');
      if (activator && popover) {
        popover.style.width = `${activator.offsetWidth}px`;
        popover.style.minWidth = `${activator.offsetWidth}px`;
        popover.style.maxWidth = `${activator.offsetWidth}px`;
      }
    }

    // Listen for popover open events (mutation observer)
    const observer = new MutationObserver(syncProfileMenuWidth);
    observer.observe(document.body, { childList: true, subtree: true });

    // Also run on window resize
    window.addEventListener('resize', syncProfileMenuWidth);

    // Clean up
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', syncProfileMenuWidth);
    };
  }, []);
}

export default useProfileMenuWidthSync; 